module.exports = __webpack_public_path__ + "img/client2C2AD6E5C21B4A0BA6F219D514B8BA92-large.c678fbae.jpg";